/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementTransferContext} from '../models/EntitlementTransferContext';
import type {Error} from '../models/Error';
import type {MigrationRelationResult} from '../models/MigrationRelationResult';

export interface ImportEntitlements$Request {
    entitlementTransferContext: EntitlementTransferContext;
}

export interface ImportEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const importEntitlementsRequest = createAction<PayloadData<void, ImportEntitlements$Request>>('ENTITLEMENT_IMPORT__IMPORT_ENTITLEMENTS__REQUEST');
export const importEntitlementsSuccess = createAction<PayloadData<Array<MigrationRelationResult>, ImportEntitlements$Request>>('ENTITLEMENT_IMPORT__IMPORT_ENTITLEMENTS__SUCCESS');
export const importEntitlementsFailure = createAction<PayloadData<Error, ImportEntitlements$Request, true>>('ENTITLEMENT_IMPORT__IMPORT_ENTITLEMENTS__FAILURE');

export const importEntitlementsActions = [
    importEntitlementsRequest,
    importEntitlementsSuccess,
    importEntitlementsFailure
] as const;

/**
 * @param {EntitlementTransferContext} meta.entitlementTransferContext
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const importEntitlements = (meta: ImportEntitlements$Request, config?: ImportEntitlements$Config) => {
    return {
        CALL_API: {
            types: importEntitlementsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/entitlements/import`,
            TRANSPORT_REQUEST_BODY: meta.entitlementTransferContext,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

